// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2c_tw","content":"styles_content__3yf_d","checkbox":"styles_checkbox__x0oKl","checkboxLabel":"styles_checkboxLabel__3HWon"};